import React from 'react';
import { Navigate } from 'react-router-dom';
import { AppRoute, SecurityLevel } from '../../app/utils/secureRoutes';
import { WatercraftFlagWrapper } from '../../common/components/FeatureFlagProtection';
import WatercraftThemeProvider from '../../features/watercraft/components/WatercraftThemeProvider';
import WatercraftSubscribePage from './WatercraftSubscribe';
import WatercraftSuccessPage from './WatercraftSuccess';
import WatercraftManagePage from './WatercraftManage';
import WatercraftLoginPage from './WatercraftLogin';
import WatercraftCreateAccountPage from './WatercraftCreateAccount';
import WatercraftPassesPage from './WatercraftPasses';
import WatercraftPassesSuccessPage from './WatercraftPassesSuccess';
import { WATERCRAFT_ROUTE } from '../../app/appConstants';
import {
  WATERCRAFT_ACCOUNT_CREATION_ROUTE,
  WATERCRAFT_LOGIN_ROUTE,
  WATERCRAFT_MANAGE_ROUTE,
  WATERCRAFT_PASSES_ROUTE,
  WATERCRAFT_PASSES_SUCCESS_ROUTE,
  WATERCRAFT_SUCCESS_ROUTE,
} from './constants';

/**
 * Wraps an element in the watercraft wrappers (theme provider and feature flag protection)
 * @param element
 */
const wrap = (element: React.JSX.Element): React.JSX.Element => (
  <WatercraftFlagWrapper>
    <WatercraftThemeProvider>{element}</WatercraftThemeProvider>
  </WatercraftFlagWrapper>
);

export const routes: AppRoute[] = [
  {
    path: WATERCRAFT_ROUTE,
    element: wrap(<WatercraftSubscribePage />),
    security: {
      level: SecurityLevel.Public,
    },
  },
  {
    path: WATERCRAFT_LOGIN_ROUTE,
    element: wrap(<WatercraftLoginPage />),
    security: {
      level: SecurityLevel.NotLoggedIn,
      redirect: WATERCRAFT_ROUTE,
    },
  },
  {
    path: WATERCRAFT_ACCOUNT_CREATION_ROUTE,
    element: wrap(<WatercraftCreateAccountPage />),
    security: {
      level: SecurityLevel.NotLoggedIn,
      redirect: WATERCRAFT_ROUTE,
    },
  },
  {
    path: WATERCRAFT_SUCCESS_ROUTE,
    element: wrap(<WatercraftSuccessPage />),
    security: {
      level: SecurityLevel.Public,
    },
  },
  {
    path: WATERCRAFT_MANAGE_ROUTE,
    element: wrap(<WatercraftManagePage />),
    security: {
      level: SecurityLevel.LoggedIn,
      redirect: WATERCRAFT_LOGIN_ROUTE,
    },
  },
  {
    path: WATERCRAFT_PASSES_ROUTE,
    element: wrap(<WatercraftPassesPage />),
    security: {
      level: SecurityLevel.Public,
    },
  },
  {
    path: WATERCRAFT_PASSES_SUCCESS_ROUTE,
    element: wrap(<WatercraftPassesSuccessPage />),
    security: {
      level: SecurityLevel.Public,
    },
  },
  {
    path: `${WATERCRAFT_ROUTE}/:other?`,
    element: <Navigate to={WATERCRAFT_ROUTE} replace />,
    security: {
      level: SecurityLevel.Public,
    },
  },
];
